(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-arena/assets/javascripts/racecards/race-summary-list.js') >= 0) return;  svs.modules.push('/modules/racing-arena/assets/javascripts/racecards/race-summary-list.js');

'use strict';

const RacePickerItem = svs.racing.RacePickerItem;
const EmptyDataView = svs.racing.emptyDataView.EmptyDataView;
const playUrl = svs.core.urlMapping.get('racing');
const raceSelector = svs.racing.RaceSelector;
const {
  buildLocationFromRace,
  locationToUrl
} = svs.racing.navigation.location;
const useRaceJackpots = svs.racing.raceService.useRaceJackpots;
const {
  racePickerModes,
  subProductIdToGameType
} = svs.racing.common.constants;
const RaceSummaryList = props => {
  const getJackpot = useRaceJackpots().getJackpot;
  const getAllJackpots = useRaceJackpots().getAllJackpots;
  const {
    emptyDataViewLabel,
    racecard,
    raceSummaries,
    racePickerMode
  } = props;
  if (svs.core.detect.formfactor.desktop() || racePickerMode === racePickerModes.TIMELINE) {
    return raceSelector(racecard, racePickerMode, emptyDataViewLabel, getJackpot, getAllJackpots);
  }
  const allJackpots = getAllJackpots();
  return React.createElement("div", {
    className: "race-summaries"
  }, raceSummaries.length > 0 ? raceSummaries.map(raceSummary => {
    var _raceSummary$meeting;
    let jackpotGameType;
    const raceJackpot = allJackpots === null || allJackpots === void 0 ? void 0 : allJackpots.find(jackpot => jackpot.raceId === raceSummary.raceId);
    if (raceJackpot) {
      jackpotGameType = subProductIdToGameType[raceJackpot.jackpots[0].userProduct];
    }
    if (raceSummary !== null && raceSummary !== void 0 && (_raceSummary$meeting = raceSummary.meeting) !== null && _raceSummary$meeting !== void 0 && _raceSummary$meeting.formattedDate) {
      return React.createElement("a", {
        href: "".concat(playUrl).concat(locationToUrl(buildLocationFromRace(raceSummary, jackpotGameType))),
        key: "racepicker_".concat(raceSummary.meeting.track.urlName, "_").concat(raceSummary.raceNumber)
      }, React.createElement(RacePickerItem, {
        isArena: true,
        isSelected: false,
        jackpot: raceJackpot,
        meeting: raceSummary.meeting,
        raceId: raceSummary.raceId,
        raceSummary: raceSummary
      }));
    }
    return null;
  }) : React.createElement(EmptyDataView, {
    label: emptyDataViewLabel
  }));
};
svs.racing_arena.RaceSummaryList = RaceSummaryList;

 })(window);